// extracted by css-extract-rspack-plugin
export default {"ThreadHeaderIconButton":"ThreadHeader-module__ThreadHeaderIconButton__Stf5fDY"};